import React from 'react'
import styled from 'styled-components'

const Tool = ({tool,delay,icon}) => {
  return (
    <Wrapper data-aos="fade-in" data-aos-delay={delay} >{icon}{tool}</Wrapper>
  )
}
const Wrapper = styled.span`
    font-family:"Righteous";
    padding:1rem;
    background:#1c1c1c;
    font-size:15px;
    font-weight:light;
    display:flex;
    align-items:center;
    gap:5px;
    color:#fff;
    border-radius: 10px;
    box-shadow: -4px -5px 6px 0px #363636, 4px 5px 6px #000;
    svg{
      font-size:25px
    }
`
export default Tool